(() => {
  const products = {
    'langhaar-tonic': 'LANGHAARMADCHEN Lovely Long Scalp Tonic, 75 ml',
    'langhaar-conditioner': 'LANGHAARMADCHEN Intense Repair Conditioner, 250 ml',
    'langhaar-ends-serum': 'LANGHAARMADCHEN Lovely Long Ends Serum, 100 ml'
  };
  const key = new URLSearchParams(location.search).get('product');
  const product = Object.hasOwn(products, key) ? products[key] : null;
  const input = document.querySelector('.dodo-product-request input[name="contact[body]"]');
  if (product && input && !input.value) input.value = product;
})();
